import { BaseQuestionnaireRoute } from '../slice';

type TaxesDeductionsSubRoutes = {
  deductions: BaseQuestionnaireRoute;
  taxesPaid: BaseQuestionnaireRoute;
  retirementSocSecurity: BaseQuestionnaireRoute;
  taxesPaidSpouse: BaseQuestionnaireRoute;
};

export type TaxesDeductionsRoutes = BaseQuestionnaireRoute &
  TaxesDeductionsSubRoutes;

export const taxesDeductionsRoutes: { taxesDeductions: TaxesDeductionsRoutes } =
  {
    taxesDeductions: {
      title: 'Tax Deductions',
      path: 'taxesDeductions',
      isValid: undefined,
      deductions: {
        title: 'Deductions',
        path: 'deductions',
        isValid: undefined,
      },
      taxesPaid: {
        title: 'Taxes Paid',
        path: 'taxesPaid',
        isValid: undefined,
      },
      retirementSocSecurity: {
        title: 'Retirement & SOC Security',
        path: 'retirementSocSecurity',
        isValid: undefined,
      },
      taxesPaidSpouse: {
        title: 'Taxes Paid Spouse',
        path: 'taxesPaidSpouse',
        isValid: undefined,
      },
    },
  };
